import { Icon } from '@chakra-ui/react';
import React from 'react';

export function DownChevron(props) {
  return (
    <Icon height="21px" viewBox="0 0 18 18" width="21px" fill="currentColor" {...props}>
      <rect id="Canvas" opacity="0" width="18" height="18" />
      <path
        className="a"
        d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z"
      />
    </Icon>
  );
}
